import { PropsWithChildren, useCallback, useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'

const KEYDOWN_EVENT_TYPE = 'keydown'
const ESC_KEY_CODE = 'Escape'

const Modal: React.FC<PropsWithChildren<Props>> = ({ children, container, closeModal }) => {
    const handleClose = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === ESC_KEY_CODE && typeof closeModal === 'function') {
                closeModal()
            }
        },
        [closeModal]
    )

    useEffect(() => {
        window.addEventListener(KEYDOWN_EVENT_TYPE, handleClose, false)
        return () => window.removeEventListener(KEYDOWN_EVENT_TYPE, handleClose, false)
    }, [handleClose])

    const containerElement = useMemo(() => {
        if (container instanceof Element) return container
        if (container) return document.querySelector(container)

        const modalContainer = document.querySelector('modal')
        if (modalContainer) return modalContainer

        const element = document.createElement('div')
        document.body.appendChild(element)
        return element
    }, [container])

    if (!containerElement) throw new Error('Cannot match element')

    return createPortal(children, containerElement)
}

export default Modal

export type Props = {
    container?: string | Element
    closeModal?: () => void
}
